export const Config = {
  BASE_URL:
    process.env.REACT_APP_STAGING_BASE_URL ||
    "https://api.dev.demo.powersmarter.net/api/",
  AUTH0_CLIENT_ID:
    process.env.REACT_APP_STAGING_AUTH0_CLIENT_ID ||
    "RLHdjXQH7M3j8Tj1ygx7t8YZ0jgZsnxH",
  AUTH0_DOMAIN:
    process.env.REACT_APP_STAGING_AUTH0_DOMAIN ||
    "dev-mgw72jpas4obd84e.us.auth0.com",
  AUTH0_AUDIENCE:
    process.env.REACT_APP_STAGING_AUTH0_API_AUDIENCE ||
    "https://api.dev.demo.powersmarter.net/",
  WEB_SOCKET_BASE_URL:
    process.env.REACT_APP_STAGING_WS_BASE_URL ||
    "ws://localhost:8002/ws/alerts/",
  // AUTH0_SECRET_KEY: process.env.REACT_APP_AUTH0_CLIENT_SECRET_KEY,
  CLOUDINARY_CLOUD_NAME: process.env.REACT_APP_CLOUDINARY_CLOUD_NAME,
  CLOUDINARY_UPLOAD_PRESET: process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET,
  CLOUDINARY_API_KEY: process.env.REACT_APP_CLOUDINARY_API_KEY,
  CLOUDINARY_API_SECRET: process.env.REACT_APP_CLOUDINARY_API_SECRET,
  SHEET_ID: "1486RAyL3Otvnll0X9gYn-rL9H1HLRn5zNboQrgjgaQg",
  SHEET_GID: "1859437090",
};
  
  // console.log("process.env.REACT_APP_BASE_URL", Config);